import React from "react";
import { useNavigate } from "react-router-dom";

import ContactData from "../components/scouting/ContactData";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../components/layout/routing/AppShell";

const ContactDataRoute = () => {
  const navigate = useNavigate();
  const { scoutData, activeSearchId } = useAuth();
  const { openNotifications } = useNotifications();

  return (
    <ContactData
      data={scoutData}
      onNotificationsClick={openNotifications}
      onSearchClick={() =>
        navigate(
          activeSearchId
            ? `/scout/searches/${activeSearchId}`
            : "/scout/searches",
        )
      }
    />
  );
};

export default ContactDataRoute;
